export enum ButtonClicked {
  SolutionClicked = 'solution_clicked',
  SolutionDeepLink = 'article_internal_link',
  SolutionLinkInternal = 'Solution Link Internal',
  Back = 'back',
  OpenArticleInHC = 'open_in_help_center',
  RecommendedArticle = 'recommended_article',
  ExpandArticleSection = 'article_section_expend',
  CollapseArticleSection = 'article_section_collapse',
  ArticleExternalLink = 'article_external_link',
  ArticleTabSelection = 'tab_selection',
  CategorySelection = 'category_selection',
  SubCategorySelection = 'sub_category_selection',
  SearchBarTextTyping = 'search_bar_text_typing',
  ClearSearchBar = 'clear_search_bar',
  HelpCenter = 'help_center',
  HomeResourcesWixLearn = 'home_resources_wix_learn',
  HomeResourcesWixBlog = 'home_resources_wix_blog',
  HomeResourcesSeo = 'home_resources_seo_learning_hub',
  HomeResourcesVelo = 'home_resources_velo_hub',
  HomeResourcesPartners = 'home_resources_partners_forum',
  HomeResourcesCustomerCareTickets = 'home_resources_customer_care_tickets',
  HomeResourcesHireProfessional = 'home_resources_hire_professional',
  HomeResourcesCommunityForum = 'home_resources_community_forum',
  HomeResourcesCommunityForumStudio = 'home_resources_community_forum_studio',
  HomeResourcesWixDevelopers = 'home_resources_wix_developers',
  HomeResourcesWixDeveloperDocs = 'home_resources_wix_developer_docs',
  HomeResourcesWixDeveloperCommunity = 'home_resources_developer_community',
  HomeResourcesChatWithUs = 'home_resources_chat_with_us',
  HomeResourcesNewReleases = 'home_resources_new_releases',
  HomeResourcesTourTheEditor = 'home_resources_editor_tour',
  HirePartner = 'hire_a_partner',
  ContactUs = 'contact_us',
  ChatWithUs = 'chat_with_us',
  StatusPage = 'status_page',
  TermsOfUse = 'terms_of_use',
  PrivacyPolicy = 'privacy_policy',
  Breadcrumbs = 'breadcrumbs',
  CloseKbWidget = 'close_kb_widget',
  Notifications = 'chatbot_notifications',
  WidgetCollapse = 'widget_collapse',
  WidgetMaximize = 'widget_maximize',
  WidgetMinimize = 'widget_minimize',
  ContactPartnerSuccessTeam = 'contact_the_partner_success_team',
  RequestFeature = 'request_a_feature',
  ReportBug = 'report_a_bug',
  RequestSuccessManagerClick = 'get_access_to_the_partner_success_team',
  FeatureRequestVote = 'feature_request_vote',
  FeatureRequestUnvote = 'feature_request_unvote',
  FeatureRequestFollow = 'feature_request_follow',
  FeatureRequestUnfollow = 'feature_request_unfollow',
  KnownIssueVote = 'known_issue_vote',
  KnownIssueUnvote = 'known_issue_unvote',
}
